// @mui
import { TableRow, TableCell, Skeleton, TableRowProps } from '@mui/material';

// ----------------------------------------------------------------------

export default function TableSkeleton({ ...other }: TableRowProps) {
  return (
    <TableRow {...other}>
      <TableCell colSpan={12}>
        <Skeleton variant="text" width="100%" height={28} />
      </TableCell>
    </TableRow>
  );
}
